<script setup lang="ts">
import { ExternalLink as LucideExternalLink } from 'lucide-vue-next'

interface Props {
  // Matches the mark to the surrounding block: the external-link badge is
  // punched out in the block's own background colour.
  badgeColorClass?: string
  sizeClass?: string
}

withDefaults(defineProps<Props>(), {
  badgeColorClass: 'bg-[#0a0e27]',
  sizeClass: 'h-10 w-10'
})
</script>

<template>
  <!-- Links out to the service behind the feature. -->
  <a
    href="https://airun.kg/"
    target="_blank"
    rel="noopener noreferrer"
    class="relative shrink-0 rounded-lg transition-opacity duration-200 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
    :title="$t('ui.tts_controls.airun_link_title')"
  >
    <svg :class="sizeClass" viewBox="0 0 1024 1024" fill="#2650D8" aria-hidden="true">
      <g transform="translate(0 1024) scale(0.1 -0.1)">
        <path
          d="M6410 10004 c-198 -23 -386 -65 -630 -139 -697 -213 -1383 -789 -1715 -1440 -74 -145 -161 -361 -180 -445 -2 -8 -12 -51 -23 -95 -157 -621 -67 -1306 250 -1903 110 -209 154 -282 168 -282 36 0 168 357 256 690 8 30 39 136 68 235 29 99 68 232 86 295 50 177 68 200 151 200 86 0 102 -23 159 -230 5 -19 32 -111 60 -205 61 -206 68 -227 125 -430 155 -543 300 -772 652 -1032 184 -136 324 -192 833 -334 58 -16 128 -36 155 -44 63 -18 381 -110 458 -132 155 -44 155 -202 0 -245 -32 -9 -144 -41 -248 -72 -105 -31 -198 -56 -207 -56 -9 0 -20 -4 -23 -10 -3 -5 -15 -10 -27 -10 -27 0 -230 -60 -242 -71 -6 -5 -6 -9 -2 -9 5 0 63 -11 130 -24 66 -13 162 -29 211 -35 50 -6 126 -17 170 -24 152 -23 581 -16 715 12 606 126 1055 520 1396 1225 257 533 349 934 349 1521 -1 316 -7 383 -64 700 -21 114 -118 423 -170 540 -5 11 -19 45 -31 75 -142 351 -459 803 -760 1083 -133 123 -397 327 -424 327 -2 0 -33 18 -69 40 -422 256 -1053 386 -1577 324z"
        />
        <path
          d="M1935 8635 c-387 -52 -723 -280 -997 -676 -48 -70 -151 -249 -167 -290 -5 -14 -18 -45 -29 -69 -156 -341 -193 -751 -96 -1061 172 -551 734 -909 1454 -926 449 -11 778 111 1055 391 528 532 534 1448 13 2089 -330 407 -779 604 -1233 542z"
        />
        <path
          d="M2494 5360 c-1111 -65 -1953 -786 -2095 -1795 -21 -147 -15 -514 10 -665 163 -984 884 -1846 1905 -2280 187 -79 510 -173 686 -200 41 -6 104 -16 140 -22 94 -17 612 -16 720 1 595 95 1025 309 1378 687 586 626 705 1592 300 2442 -46 96 -47 96 -89 35 -109 -158 -227 -460 -308 -788 -10 -43 -16 -64 -85 -295 -25 -85 -50 -171 -56 -190 -47 -169 -51 -179 -81 -204 -42 -36 -115 -36 -157 -2 -26 22 -60 111 -78 199 -1 10 -8 32 -14 50 -16 49 -116 393 -165 567 -98 351 -149 475 -276 666 -189 284 -531 535 -843 619 -28 7 -123 35 -211 61 -88 25 -189 55 -225 65 -314 86 -599 172 -620 187 -38 29 -52 90 -31 138 22 49 33 58 101 77 277 81 410 119 495 142 213 59 573 166 625 187 75 30 212 102 213 114 2 10 -176 74 -293 105 -306 81 -646 116 -946 99z"
        />
        <path
          d="M7510 3881 c-227 -25 -524 -127 -735 -252 -698 -414 -931 -1306 -548 -2096 462 -956 1767 -1271 2619 -632 729 547 821 1684 196 2405 -349 402 -972 635 -1532 575z"
        />
      </g>
    </svg>

    <!-- Sits on the mark's corner rather than after it: the row is width capped,
         and an inline icon would compete with the label. -->
    <LucideExternalLink
      class="absolute -right-1 -top-1 h-4 w-4 rounded-full p-px text-white/70"
      :class="badgeColorClass"
    />
  </a>
</template>
